import { Step } from 'react-joyride';

export const mobileTourSteps: Step[] = [
  {
    target: '[data-mobile-tour="dashboard"]',
    content: 'Welcome to HEAT! This is your Dashboard — the central hub for strategic intelligence. Let\'s take a quick tour of the key features.',
    title: 'Welcome to HEAT!',
    disableBeacon: true,
    placement: 'top',
  },
  {
    target: '[data-mobile-tour="monitoring"]',
    content: 'The Monitoring section tracks all relevant media coverage and scores articles based on their relevance and sentiment to your organization.',
    title: 'Media Monitoring',
    placement: 'top',
  },
  {
    target: '[data-mobile-tour="issues"]',
    content: 'The Issues section helps you track and manage strategic issues affecting your organization. Each issue is prioritized and linked to relevant stakeholders.',
    title: 'Issue Tracking',
    placement: 'top',
  },
  {
    target: '[data-mobile-tour="stakeholders"]',
    content: 'Here you\'ll find all stakeholders relevant to your organization, with their influence levels, interest levels, and relationship status. That\'s the end of the tour — enjoy using HEAT!',
    title: 'Stakeholder Directory',
    placement: 'top',
  },
];
